//...
import * as Sentry from "@sentry/react";

import { environment } from "./environment";

export const initializeSentry = (): any => {
  if (window.location.hostname !== "localhost") {
    Sentry.init({
      dsn: "https://f98f31108c8bacefeaabd318b1c8fe0f@o4508143951872000.ingest.us.sentry.io/4508143959015424",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration(),
      ],
      environment: environment,
      // Tracing
      tracesSampleRate: 0.1, // Sample 10% of transactions to reduce client perf overhead
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      // Effective profiling rate = tracesSampleRate * profilesSampleRate = 0.01 (1%)
      profilesSampleRate: 0.1,
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

      beforeSend(event, hint) {
        const error = hint?.originalException;

        // Axios Error object shape
        if (error && typeof error === "object") {
          const maybeAxiosError = error as any;

          // Ignore plain "Network Error" with no response
          if (maybeAxiosError.message === "Network Error" && !maybeAxiosError.response) {
            return null;
          }

          // Example: keep 404 / 500
          if (maybeAxiosError.response?.status) {
            // Optionally: log only 5xx, ignore 4xx
            if (maybeAxiosError.response.status >= 500) {
              return event; // send server failures
            } else {
              return null; // ignore client errors like 400, 404
            }
          }
        }

        // Keep all other errors
        return event;
      },
    });
  }
};
